import { render, staticRenderFns } from "./TourControlls.vue?vue&type=template&id=6cd9e96b&scoped=true&lang=pug&"
import script from "./TourControlls.vue?vue&type=script&lang=js&"
export * from "./TourControlls.vue?vue&type=script&lang=js&"
import style0 from "./TourControlls.vue?vue&type=style&index=0&id=6cd9e96b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd9e96b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
